import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') || categories[0].slug;
  const [activeTab, setActiveTab] = useState(initialTab);

  useEffect(() => {
    const tab = searchParams.get('tab');
    if (tab && tab !== activeTab) {
      setActiveTab(tab);
    }
  }, [searchParams, activeTab]);

  const handleTabChange = (slug: string) => {
    setActiveTab(slug);
    setSearchParams({ tab: slug });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const activeCategory = categories.find((c) => c.slug === activeTab);

  return (
    <main className="pt-16">
      <section className="py-12 md:py-16 bg-background-50 border-b border-background-200">
        <div className="w-full px-4 md:px-6">
          <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-4" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-900 font-medium">服务分类</span>
          </nav>
          <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            服务分类
          </h1>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl leading-relaxed">
            选择你感兴趣的服务类别，发现比基尼护士的完整服务体系
          </p>
        </div>
      </section>

      <section className="py-8 md:py-10 bg-background-50">
        <div className="w-full px-4 md:px-6">
          <div className="flex flex-wrap items-center gap-3 mb-10">
            {categories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => handleTabChange(cat.slug)}
                className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeTab === cat.slug
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200'
                }`}
              >
                <i className={`${cat.icon} text-base`}></i>
                {cat.name}
              </button>
            ))}
          </div>

          {activeCategory && (
            <>
              <div className="relative rounded-lg overflow-hidden mb-10 h-48 md:h-64">
                <img
                  src={activeCategory.image}
                  alt={activeCategory.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/55 to-transparent flex items-center">
                  <div className="p-6 md:p-10 max-w-lg">
                    <h2 className="font-heading text-xl md:text-3xl font-bold text-white mb-2">
                      {activeCategory.name}
                    </h2>
                    <p className="text-white/80 text-sm leading-relaxed hidden sm:block">
                      {activeCategory.description}
                    </p>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
                {activeCategory.items.map((item) => (
                  <div
                    key={item.id}
                    className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300"
                  >
                    <div className="relative h-72 overflow-hidden">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                      {item.tag && (
                        <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-white text-xs font-medium rounded-md">
                          {item.tag}
                        </span>
                      )}
                    </div>
                    <div className="p-4">
                      <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">
                        {item.title}
                      </h3>
                      <p className="text-foreground-600 text-xs leading-relaxed mb-3 line-clamp-2">
                        {item.description}
                      </p>
                      <div className="flex items-center justify-between">
                        <span className="text-primary-500 text-sm font-semibold">{item.price}</span>
                        <button className="px-3 py-1.5 bg-primary-50 text-primary-600 text-xs font-medium rounded-md hover:bg-primary-100 transition-colors whitespace-nowrap cursor-pointer">
                          预约咨询
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </section>
    </main>
  );
}